import React from 'react';
import axios from '../../../../axios/index';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


// Styles
import styles from "../../DashboardFileManagement/DashboardFileManagement.module.css"
import archiveStyles from "../../DashboardArchivedFiles/ArchiveDetail/ArchiveDetail.module.css"

export default function ArchiveData(props) {
    const [cursor, setCursor] = React.useState('pointer');
    return (
        <>
            <ToastContainer
                position="top-right"
                autoClose={9000}
                hideProgressBar={false}
                newestOnTop
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover={false}
                theme="light"
            />
            {props?.limits?.find((item) => item === "archiveDetails") ?
                <></> : <div className='w-100 d-flex flex-column align-items-start justify-content-center flex-wrap mt-4 mb-4 px-4'>
                    <div className={styles.title}>
                        اطلاعات آرشیو
                    </div>
                    <div className='w-100 d-flex align-items-center my-4 flex-wrap'>
                        <div className={`d-flex align-items-center justify-content-start my-md-0 my-3 ${archiveStyles.archive_title_container}`}>
                            <div className={`d-flex align-items-center justify-content-center position-relative ${archiveStyles.line_green}`}>
                                <div className='d-flex flex-column align-items-start justify-content-start pe-2'>
                                    <h5 className={styles.card_main_detail_text1}>علت آرشیو</h5>
                                    <div className={styles.card_main_detail_text2}>
                                        {props?.archiveData?.archiveReason}
                                    </div>
                                </div>
                            </div>
                        </div>

                        {!props?.archiveData?.isDel? <div className={`d-flex align-items-center justify-content-start my-md-0 my-3 ${archiveStyles.archive_title_container}`}>
                            <div className={`d-flex align-items-center justify-content-center position-relative ${archiveStyles.line_green}`}>
                                <div className='d-flex flex-column align-items-start justify-content-start pe-2'>
                                    <h5 className={styles.card_main_detail_text1}>مدت زمان قرار داد</h5>
                                    <div className={styles.card_main_detail_text2}>
                                        {props?.archiveData?.contractEndDate?.toString()?.replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d])}
                                        {/* {"2 سال")} */}
                                    </div>
                                </div>
                            </div>
                        </div> : <></>}
                    </div>

                    <div className="w-100 d-flex align-items-center justify-content-start my-3">
                        <div className={`d-flex align-items-center justify-content-center position-relative ${archiveStyles.line_green}`}>
                            <div className='d-flex flex-column align-items-start justify-content-start pe-2'>
                                <h5 className={styles.card_main_detail_text1}>توضیحات</h5>
                                <div className={styles.card_main_detail_text2} style={{ textAlign: "right" }}>
                                    {props?.archiveData?.description?.toString()?.replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d])}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="w-100 d-flex align-items-center justify-content-start my-3">
                        <div className={`d-flex align-items-center justify-content-center position-relative ${archiveStyles.line_green}`}>
                            <div className='d-flex flex-column align-items-start justify-content-start pe-2'>
                                <h5 className={styles.card_main_detail_text1}>نوع آرشیو</h5>
                                <div className={styles.card_main_detail_text2} style={{ textAlign: "right" }}>
                                    {props?.archiveData?.isDel? "حذف" : "بایگانی"}
                                </div>
                            </div>
                        </div>
                    </div>

                    {!props?.archiveData?.isDel? <div className="w-100 d-flex align-items-center justify-content-start my-3">
                        <div className={`d-flex align-items-center justify-content-center position-relative ${archiveStyles.line_green}`}>
                            <div className='d-flex flex-column align-items-start justify-content-start pe-2'>
                                <h5 className={styles.card_main_detail_text1}>فایل مدارک</h5>
                                <div className={`d-flex align-items-center justify-content-center ${archiveStyles.download_box}`}>
                                    <svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg" className='ms-3'>
                                        <path fillRule="evenodd" clipRule="evenodd" d="M0.769231 8.25806C1.19407 8.25806 1.53846 8.60468 1.53846 9.03226V12.795C1.53846 13.46 2.03556 14.0049 2.68081 14.0597C4.63373 14.2255 7.7196 14.4516 10 14.4516C12.2804 14.4516 15.3663 14.2255 17.3192 14.0597C17.9644 14.0049 18.4615 13.46 18.4615 12.795V9.03226C18.4615 8.60468 18.8059 8.25806 19.2308 8.25806C19.6556 8.25806 20 8.60468 20 9.03226V12.795C20 14.2514 18.9036 15.479 17.4485 15.6026C15.494 15.7685 12.3512 16 10 16C7.64875 16 4.50602 15.7685 2.55147 15.6026C1.09638 15.479 0 14.2514 0 12.795V9.03226C0 8.60468 0.344396 8.25806 0.769231 8.25806Z" fill="#21409A" />
                                        <path fillRule="evenodd" clipRule="evenodd" d="M9.45607 9.57969C9.75648 9.88204 10.2435 9.88204 10.5439 9.57969L13.6209 6.48292C13.9213 6.18058 13.9213 5.69039 13.6209 5.38805C13.3204 5.0857 12.8334 5.0857 12.533 5.38805L10.7692 7.16319V0.774194C10.7692 0.346619 10.4248 0 10 0C9.57517 0 9.23077 0.346619 9.23077 0.774194V7.16319L7.46701 5.38805C7.1666 5.0857 6.67955 5.0857 6.37915 5.38805C6.07875 5.69039 6.07875 6.18058 6.37915 6.48292L9.45607 9.57969Z" fill="#21409A" />
                                    </svg>
                                    <div className={archiveStyles.download_btn} onClick={handleDownload} style={{ cursor: cursor }}>
                                        دانلود فایل
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div> : <></>}
                </div>}

            {props?.archiveData?.reminder?.isActive &&
                <div className={`w-100 d-flex flex-column align-items-center justify-content-start flex-wrap mt-4 mb-4 mx-3 p-4 ${archiveStyles.archive_reminder_container}`}>
                    <div className='w-100 d-flex align-items-center justify-content-md-between justify-content-center flex-wrap py-md-0 py-2 mb-4'>
                        <div className='d-flex align-items-center justify-content-center m-md-0 my-2'>
                            <div className={`d-flex align-items-center justify-content-center ms-3 ${archiveStyles.reminder_icon_container}`} >
                                <svg xmlns="http://www.w3.org/2000/svg" width="19" height="18" fill={props?.archiveData?.isReminder === true ? "#21409a" : "#8D8D8D"}
                                    className={`bi bi-alarm ${archiveStyles.reminder_icon}`} viewBox="0 0 16 16">
                                    <path d="M8.5 5.5a.5.5 0 0 0-1 0v3.362l-1.429 2.38a.5.5 0 1 0 .858.515l1.5-2.5A.5.5 0 0 0 8.5 9V5.5z" />
                                    <path d="M6.5 0a.5.5 0 0 0 0 1H7v1.07a7.001 7.001 0 0 0-3.273 12.474l-.602.602a.5.5 0 0 0 .707.708l.746-.746A6.97 6.97 0 0 0 8 16a6.97 6.97 0 0 0 3.422-.892l.746.746a.5.5 0 0 0 .707-.708l-.601-.602A7.001 7.001 0 0 0 9 2.07V1h.5a.5.5 0 0 0 0-1h-3zm1.038 3.018a6.093 6.093 0 0 1 .924 0 6 6 0 1 1-.924 0zM0 3.5c0 .753.333 1.429.86 1.887A8.035 8.035 0 0 1 4.387 1.86 2.5 2.5 0 0 0 0 3.5zM13.5 1c-.753 0-1.429.333-1.887.86a8.035 8.035 0 0 1 3.527 3.527A2.5 2.5 0 0 0 13.5 1z" />
                                </svg>
                            </div>

                            <div className={archiveStyles.archive_reminder_text_title} style={props?.archiveData?.isReminder === true ? { color: "#21409a" } : { color: "#8D8D8D" }}>
                                یادآور
                            </div>
                        </div>

                        <div className='d-flex align-items-center m-md-0 my-2'>
                            <div className="d-flex align-items-center justify-content-center ms-2">
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="#8D8D8D" className="ms-3 bi bi-calendar" viewBox="0 0 16 16">
                                    <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z" />
                                </svg>
                                <p className={`m-0 ${archiveStyles.archive_reminder_text_title2}`}>
                                    تاریخ:
                                </p>
                            </div>
                            <div className={archiveStyles.archive_reminder_text_title}>
                                {props?.archiveData?.reminder.reminderDate?.toString()?.replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d])}
                            </div>
                        </div>

                        <div className='d-flex align-items-center m-md-0 my-2 ms-md-0 ms-4'>
                            <div className="d-flex align-items-center justify-content-center ms-2">
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="#8D8D8D" className="ms-3 bi bi-clock" viewBox="0 0 16 16">
                                    <path d="M8 3.5a.5.5 0 0 0-1 0V9a.5.5 0 0 0 .252.434l3.5 2a.5.5 0 0 0 .496-.868L8 8.71V3.5z" />
                                    <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm7-8A7 7 0 1 1 1 8a7 7 0 0 1 14 0z" />
                                </svg>
                                <p className={`m-0 ${archiveStyles.archive_reminder_text_title2}`}>
                                    ساعت:
                                </p>
                            </div>
                            <div className={archiveStyles.archive_reminder_text_title}>
                                {props?.archiveData?.reminder.reminderTime?.toString()?.replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d])}
                            </div>
                        </div>

                        <div className='d-flex align-items-center m-md-0 my-2 '>
                            <div className={archiveStyles.text_primary} onClick={props?.archiveData?.reminder.isActive && props?.reminderHandler}>
                                {
                                    props?.archiveData?.reminder.isActive === true ? "غیرفعال سازی" : "یادآور تنظیم نشده است"
                                }
                            </div>
                        </div>
                    </div>

                    {/* <div className='w-100 d-flex align-items-center justify-content-between flex-wrap py-md-0 py-2 my-2'>
                        <h5 className={styles.card_main_detail_text1}>توضیحات:</h5>
                        <div className={styles.card_main_detail_text2} style={{ textAlign: "right" }}>
                            لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد تا با نرم افزارها شناخت بیشتری را برای طراحان رایانه ای علی الخصوص طراحان خلاقی و فرهنگ پیشرو در زبان فارسی ایجاد کرد.
                        </div>
                    </div> */}
                </div>
            }
        </>
    )

    function notify(text, type) {
        if (type === "success") {
            toast.success(text, {
                position: "top-right",
                autoClose: 10000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        } else {
            toast.error(text, {
                position: "top-right",
                autoClose: 10000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
            setCursor("pointer")
        }
    };

    async function handleDownload() {
        try {
            setCursor("wait")
            const fileType = props?.archiveData.images[0].imageFileName.split(".")
            const response = await axios({
                url: `https://backdev.azrmelk.com/api/Archive/DownloadFile/${props?.archiveData.images[0].imageFileName}`,
                method: 'GET',
                responseType: 'blob',
            });
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `file.${fileType[1]}`);
            document.body.appendChild(link);
            link.click();
        } catch (error) {
            notify("فایل یافته نشد", "error")
        }
        setCursor("pointer")
    };
}
